"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deselectNode = exports.selectNode = exports.selectionContainsPosition = void 0;
const kendo_react_editor_1 = require("@progress/kendo-react-editor");
function selectionContainsPosition(selection, pos) {
    const found = selection.from <= pos && pos < selection.to;
    return found;
}
exports.selectionContainsPosition = selectionContainsPosition;
function setNodeSelectedAttribute(args) {
    const { schema, json, transaction, pos, selected } = args;
    const replacementNode = kendo_react_editor_1.ProseMirror.Node.fromJSON(schema, {
        ...json,
        attrs: {
            ...json.attrs,
            selected
        }
    });
    return transaction.replaceWith(pos, pos + 1, replacementNode);
}
function selectNode(args) {
    return setNodeSelectedAttribute({ ...args, selected: "true" });
}
exports.selectNode = selectNode;
function deselectNode(args) {
    return setNodeSelectedAttribute({ ...args, selected: "false" });
}
exports.deselectNode = deselectNode;
//# sourceMappingURL=ZEditorUtils.js.map